// extracted by mini-css-extract-plugin
export var baseButton = "_p7-0";
export var controlsArrowKeys = "_p7-1";
export var controlsResetButton = "_p7-2";
export var lightGameButton = "_p7-4 _p7-0";
export var playAgainButton = "_p7-5 _p7-0";
export var startGameButton = "_p7-3 _p7-0";